/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetResourceCloudRegionsQuery,
  CloudAccountCloudProvider,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

export function useGetResourceCloudRegions(
  provider?: CloudAccountCloudProvider
) {
  const { data, loading } = useGetResourceCloudRegionsQuery({
    onError: (error) => {
      showError(error.message);
    },
  });

  switch (provider) {
    case CloudAccountCloudProvider.Aws:
      return { data: data?.resourceCloudRegions.aws, loading };
    case CloudAccountCloudProvider.Azure:
      return { data: data?.resourceCloudRegions.azure, loading };
    case CloudAccountCloudProvider.Gc:
      return { data: data?.resourceCloudRegions.gc, loading };
    default:
      return {
        data: [
          ...(data?.resourceCloudRegions.aws ?? []),
          ...(data?.resourceCloudRegions.azure ?? []),
          ...(data?.resourceCloudRegions.gc ?? []),
          ...(data?.resourceCloudRegions.ibm ?? []),
        ],
        loading,
      };
  }
}
